import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList';

export default RecapProductList;
